import axios from "axios";
const backend_url = process.env.VUE_APP_HOSTNAME
const domain_url = process.env.VUE_APP_DOMAIN
const ENV = process.env.NODE_ENV
const MODE = process.env.VUE_APP_MODE
const SUPPORT_BOT = (process.env.VUE_APP_AUTH_BOT) ? process.env.VUE_APP_AUTH_BOT : ''
const VERSION = (process.env.VUE_APP_VERSION) ? process.env.VUE_APP_VERSION : '1'
export default class Connect {
    constructor() {

    }

    // Public
    async AddPublicClient(data){
        const response = await axios.post(`/api/public/client/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error AddPublicClient()')
            return Promise.resolve({result: false})
        }
    }

    async PublicSendToKyc(data) {
        const response = await axios.post(`/api/public/client/send_to_kyc/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            console.log('error PublicSendToKyc()')
            return Promise.resolve({result: false})
        }
    }

    async PublicKycStatus(data) {
        const response = await axios.post(`/api/public/client/kyc_status/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error PublicKycStatus()')
            return Promise.resolve({result: false})
        }
    }

    async GetPublicFiles(user_login, client_id, limit, skip, filter) {
        const response = await axios.post(`/api/public/client/files/`, {user_login, client_id, limit, skip, filter}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetPublicFiles()')
            return Promise.resolve({result: false})
        }
    }

    async UploadPublicFiles(userLogin, formData) {
        const response = await axios.post(`/api/public/files/upload/${userLogin}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // Personal
    async GetPersonalClients(limit, skip, filter, sort) {
        const response = await axios.post(`/api/personal/clients/`, {limit, skip, filter, sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetPersonalClients()')
            return Promise.resolve({result: false})
        }
    }

    async AddPersonalOrder(data){
        const response = await axios.post(`/api/personal/orders/add/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error AddPersonalOrder()')
            return Promise.resolve({result: false})
        }
    }

    async AddPersonalClient(data){
        const payload = {
            ...data,
            // API ожидает телефон строкой, даже если поле ввода вернуло число.
            phone: data?.phone != null ? String(data.phone) : '',
        }
        const response = await axios.post(`/api/personal/clients/add/`, payload).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error AddPersonalClient()')
            return Promise.resolve({result: false})
        }
    }

    async UpdatePersonalClient(id, data) {
        const payload = {
            ...data,
            // API ожидает телефон строкой, даже если поле ввода вернуло число.
            phone: data?.phone != null ? String(data.phone) : '',
        }
        const response = await axios.put(`/api/personal/clients/${id}`, payload).then(res=>res).catch(error => error?.response)
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error UpdatePersonalClient()')
            return Promise.resolve(response && response.data ? response.data : {result: false})
        }
    }

    async GetPersonalOrders(limit, skip, filter, sort) {
        const response = await axios.post(`/api/personal/orders/`, {limit, skip, filter, sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetPersonalOrders()')
            return Promise.resolve({result: false})
        }
    }

    async GetPersonalOrder(id) {
        const response = await axios.get(`/api/personal/orders/${id}`).then(res=>res).catch(error => error?.response)
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetPersonalOrder()')
            return Promise.resolve(response && response.data ? response.data : {result: false})
        }
    }

    async GetPersonalOrderStatus(order_id) {
        const response = await axios.get(`/api/personal/orders/status/${order_id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetPersonalOrderStatus()')
            return Promise.resolve({result: false})
        }
    }

    async RefundPersonalOrder(id) {
        const response = await axios.get(`/api/personal/orders/refund/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            console.log('error RefundPersonalOrder()')
            return Promise.resolve({ result: false })
        }
    }

    async GetPersonalOrderStat() {
        const response = await axios.get(`/api/personal/stat/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetPersonalOrders()')
            return Promise.resolve({result: false})
        }
    }

    async UploadFiles(formData) {
        const response = await axios.post(`/api/personal/files/upload/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    async GetPersonalFiles(limit, skip, filter) {
        const response = await axios.post(`/api/personal/files/`, {limit, skip, filter}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetPersonalFiles()')
            return Promise.resolve({result: false})
        }
    }

    async PersonalSendToKyc(data) {
        const response = await axios.post(`/api/personal/clients/send_to_kyc/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            console.log('error PersonalSendClientToKyc()')
            return Promise.resolve({result: false})
        }
    }

    async PersonalKycStatus(client_id) {
        const response = await axios.get(`/api/personal/clients/kyc_status/${client_id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error PersonalKycStatus()')
            return Promise.resolve({result: false})
        }
    }

    async GetPersonalSubscriptions(limit=10, skip=0, filter={}, sort={}) {
        const response = await axios.post(`/api/personal/subscription/list/`, {limit, skip, filter, sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetPersonalSubscriptions()')
            return Promise.resolve({result: false})
        }
    }

    async AddPersonalSubscription(data) {
        const response = await axios.post(`/api/personal/subscription/add/`, data).then(res=>res).catch(error => error?.response)
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error AddPersonalSubscription()')
            return Promise.resolve(response && response.data ? response.data : {result: false})
        }
    }

    async GetPersonalSubscriptionStatus(subscription_id) {
        const response = await axios.get(`/api/personal/subscription/${subscription_id}/status`).then(res=>res).catch(error => error?.response)
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error GetPersonalSubscriptionStatus()')
            return Promise.resolve(response && response.data ? response.data : {result: false})
        }
    }

    async CancelPersonalSubscription(subscription_id) {
        const response = await axios.get(`/api/personal/subscription/${subscription_id}/cancel`).then(res=>res).catch(error => error?.response)
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error CancelPersonalSubscription()')
            return Promise.resolve(response && response.data ? response.data : {result: false})
        }
    }

    async GetPersonalWallet() {
        const response = await axios.get(`/api/personal/wallet/`).then(res=>res).catch(error => {})
            if (response && response.status === 200) {
                return Promise.resolve(response.data)
            }else{
            console.log('error GetPersonalWallet()')
            return Promise.resolve({result: false})
        }
    }

    async GetPersonalAccount (id, limit, skip, filter, sort) {
        const response = await axios.post(`/api/personal/account/get/`, {id: id, limit: limit, skip: skip, filter: filter, sort: sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetPersonalAccount()')
            return Promise.resolve({result: false})
        }
    }

    async GetPersonalOperationsByAccount (account_id, limit=10, skip=0, filter={}, sort={}) {
        const response = await axios.post(`/api/personal/operations/`, {account_id, limit, skip, filter, sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetPersonalOperationsByAccount()')
            return Promise.resolve({result: false})
        }
    }

    // Admin
    async GetAdminOrders(limit, skip, filter, sort) {
        const response = await axios.post(`/api/admin/orders/`, {limit, skip, filter, sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetAdminOrders()')
            return Promise.resolve({result: false})
        }
    }

    async GetAdminOrder(id) {
        const response = await axios.get(`/api/admin/orders/${id}`).then(res=>res).catch(error => error?.response)
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetAdminOrder()')
            return Promise.resolve(response && response.data ? response.data : {result: false})
        }
    }

    async GetAdminOrderStatus(order_id) {
        const response = await axios.get(`/api/admin/order/status/${order_id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetAdminOrderStatus()')
            return Promise.resolve({result: false})
        }
    }

    async GetAdminOrderStat() {
        const response = await axios.get(`/api/admin/order/stat/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetAdminOrderStat()')
            return Promise.resolve({result: false})
        }
    }

    async GetAdminUsers() {
        const response = await axios.get(`/api/admin/users/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetAdminUsers()')
            return Promise.resolve({result: false})
        }
    }

    async AddAdminUser(data) {
        const response = await axios.post(`/api/admin/users/add/`, data).then(res=>res).catch(error => error?.response)
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error AddAdminUser()')
            return Promise.resolve(response && response.data ? response.data : {result: false})
        }
    }

    async EditAdminUser(data) {
        const response = await axios.post(`/api/admin/users/edit/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error EditAdminUser()')
            return Promise.resolve({result: false})
        }
    }

    async GetAdminUserById(id) {
        const response = await axios.get(`/api/admin/users/get_by_id/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetAdminUserById()')
            return Promise.resolve({result: false})
        }
    }

    async GetAdminClients(limit, skip, filter, sort) {
        const response = await axios.post(`/api/admin/clients/`, {limit, skip, filter, sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetAdminClients()')
            return Promise.resolve({result: false})
        }
    }

    async EditAdminOrder(data) {
        const response = await axios.post(`/api/admin/order/edit/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            console.log('error EditAdminOrder()')
            return Promise.resolve({ result: false })
        }
    }

    async RefundAdminOrder(id) {
        const response = await axios.get(`/api/admin/order/refund/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            console.log('error RefundAdminOrder()')
            return Promise.resolve({ result: false })
        }
    }

    async BulkEditAdminOrders(data) {
        const response = await axios.post(`/api/admin/order/status/bulk/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            console.log('error BulkEditAdminOrders()')
            return Promise.resolve({ result: false })
        }
    }

    // ADMIN-WALLET
    async GetAdminWalletList(limit, skip, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/wallet/list/`, {limit: limit, skip: skip, filter: filter, sort: sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetAdminWalletList()')
            return Promise.resolve({result: false})
        }
    }

    async GetAdminWallet(id) {
        const response = await axios.get(`/api/admin/wallet/get_by_id/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetAdminWallet()')
            return Promise.resolve({result: false})
        }
    }
    
    async TopupWalletByAdmin(data){
        const response = await axios.post(`/api/admin/wallet/topup/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    async WithdrawWalletByAdmin(data){
        const response = await axios.post(`/api/admin/wallet/withdraw/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    async TransferWalletByAdmin(data){
        const response = await axios.post(`/api/admin/wallet/transfer/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    async ExchangeWallet(data){
        const response = await axios.post(`/api/admin/wallet/exchange/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    async CommitTransferWalletByAdmin(operation_id, data = {}){
        const response = await axios.post(`/api/admin/wallet/transfer/commit/`, {operation_id, ...data}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    async RevertTransferWalletByAdmin(operation_id, data = {}){
        const response = await axios.post(`/api/admin/wallet/transfer/revert/`, {operation_id, ...data}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    async CreateWalletMerchant (data) {
        const response = await axios.post(`/api/admin/wallet/create_mr/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error CreateWalletMerchant()')
            return Promise.resolve({result: false})
        }
    }

    // ADMIN-ACCOUNT
    async GetAdminAccountList (limit, skip, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/account/list/`, {limit: limit, skip: skip, filter: filter, sort: sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetAdminAccountList()')
            return Promise.resolve({result: false})
        }
    }

    async GetAdminAccount (id, limit, skip, filter, sort) {
        const response = await axios.post(`/api/admin/account/get/`, {id: id, limit: limit, skip: skip, filter: filter, sort: sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetAdminAccount()')
            return Promise.resolve({result: false})
        }
    }

    // ADMIN-TRANSACTION
    async GetAdminTransactionList (limit, skip, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/transaction/list/`, {limit: limit, skip: skip, filter: filter, sort:sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetAdminTransactionList()')
            return Promise.resolve({result: false})
        }
    }

    // ADMIN-OPERATION
    async GetAdminOperationList (limit=10, skip=0, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/operation/list/`, {limit, skip, filter, sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetAdminOperationList()')
            return Promise.resolve({result: false})
        }
    }

    async GetAdminOperationsByAccount (account_id, limit=10, skip=0, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/operation/account/`, {account_id, limit, skip, filter, sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetAdminOperationsByAccount()')
            return Promise.resolve({result: false})
        }
    }

    // ADMIN-SUBSCRIPTION
    async GetAdminSubscriptions (limit=10, skip=0, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/subscription/list/`, {limit, skip, filter, sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetAdminSubscriptions()')
            return Promise.resolve({result: false})
        }
    }

    async AddAdminSubscription(data) {
        const response = await axios.post(`/api/admin/subscription/add/`, data).then(res=>res).catch(error => error?.response)
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error AddAdminSubscription()')
            return Promise.resolve(response && response.data ? response.data : {result: false})
        }
    }

    async GetAdminSubscriptionStatus(subscription_id) {
        const response = await axios.get(`/api/admin/subscription/${subscription_id}/status`).then(res=>res).catch(error => error?.response)
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error GetAdminSubscriptionStatus()')
            return Promise.resolve(response && response.data ? response.data : {result: false})
        }
    }

    async ChargeAdminSubscription(subscription_id) {
        const response = await axios.get(`/api/admin/subscription/${subscription_id}/charge`).then(res=>res).catch(error => error?.response)
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error ChargeAdminSubscription()')
            return Promise.resolve(response && response.data ? response.data : {result: false})
        }
    }

    async CancelAdminSubscription(subscription_id) {
        const response = await axios.get(`/api/admin/subscription/${subscription_id}/cancel`).then(res=>res).catch(error => error?.response)
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error CancelAdminSubscription()')
            return Promise.resolve(response && response.data ? response.data : {result: false})
        }
    }

    async GetAdminSubscriptionAttempts (limit=10, skip=0, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/subscription/attempts/list`, {limit, skip, filter, sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetAdminSubscriptionAttempts()')
            return Promise.resolve({result: false})
        }
    }

    async GetAdminSubscriptionEvents (limit=10, skip=0, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/subscription/events/list`, { limit, skip, filter, sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetAdminSubscriptionEvents()')
            return Promise.resolve({result: false})
        }
    }

    // ADMIN-RATES
    async GetAdminRatesList(limit=10, skip=0, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/rates/list/`, { limit, skip, filter, sort }).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetAdminRatesList()')
            return Promise.resolve({result: false})
        }
    }

    async GetAdminRatesValuesList(limit=10, skip=0, filter={}, sort={}, date_from=null, date_to=null) {
        const response = await axios.post(`/api/admin/rates/values/list/`, { limit, skip, filter, sort, date_from, date_to }).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetAdminRatesValuesList()')
            return Promise.resolve({result: false})
        }
    }
}

